function trimUrl(value) {
  return String(value ?? '').trim()
}

function previewUrlFromImage(image) {
  const variants = image?.variants
  if (!variants || typeof variants !== 'object') {
    return ''
  }
  return (
    trimUrl(variants.mid) ||
    trimUrl(variants.default) ||
    trimUrl(variants.small) ||
    trimUrl(variants.large)
  )
}

export function mapProductImagesFromApi(raw) {
  const fileIds = Array.isArray(raw?.image_file_ids)
    ? raw.image_file_ids.map((id) => String(id ?? '').trim()).filter(Boolean)
    : []
  const images = Array.isArray(raw?.images) ? raw.images : []

  return fileIds.map((fileId, index) => ({
    fileId,
    previewUrl: previewUrlFromImage(images[index]),
  }))
}

export function buildProductImageFileIds(productImages) {
  return (Array.isArray(productImages) ? productImages : [])
    .map((item) => String(item?.fileId ?? '').trim())
    .filter(Boolean)
    .slice(0, 5)
}
